<template>
  <div>
    <el-table
        :data="channels.data"
        class="w100"
        stripe
        v-loading="loading"
    >
      <el-table-column label="Campaign" prop="campaign_name" sortable></el-table-column>
      <el-table-column label="Track" prop="track_name" sortable></el-table-column>
      <el-table-column label="Channel" prop="channel_id" sortable></el-table-column>
      <el-table-column label="Channel Share">
        <template slot-scope="props">
          {{ props.row.channel_share }}%
        </template>
      </el-table-column>
      <el-table-column label="Platform Share">
        <template slot-scope="props">
          {{ props.row.platform_share }}%
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('revShareCampaigns', ['channels', "loading"])
  },

  methods: {
    ...mapMutations('revShareCampaigns', ['setChannelModal']),
    ...mapActions('revShareCampaigns', ['readChannels']),
  },

  created() {
    this.readChannels()
    this.setChannelModal(false)
  }
}
</script>
]
